var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('page-poster',{staticClass:"uninstall-extension-poster",attrs:{"headline":_vm.$t('uninstall.extension.headline'),"paragraphs":[_vm.$t('uninstall.extension.paragraph-1'), _vm.$t('uninstall.extension.paragraph-2')]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }